import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { ConfigService } from '../../lib/service';
import { Router } from '@angular/router';
import Modo from '../../enums/modo';


import {
    ResultadoPesquisa,
    Produto
} from '../../lib/model';

@Component({
    selector: 'resultado-pesquisa',
    template: require('./resultado-pesquisa.component.html'),
    styles: [require('./resultado-pesquisa.component.css')]
})

export class ResultadoPesquisaComponent implements OnInit {

    @Input() 
    resultado: ResultadoPesquisa;

    @Output() 
    localizarNoMapaEmitter = new EventEmitter();

    private config: ConfigService;

    //public produtosExibicao: Array<Produto>;

    constructor(private _router: Router, private _config: ConfigService) 
    {
        this.config = this._config;
        //this.produtosExibicao = new Array<Produto>();
    }

    ngOnInit() { 
             
    }


    mostrarProdutos(resultado: ResultadoPesquisa)
    {        
        var modalTrigger = document.getElementById('hiddenModalTrigger');
        
        if(modalTrigger)
        {
            modalTrigger.click();
        }
    }

    localizarNoMapa(resultado: ResultadoPesquisa)
    {
        this.localizarNoMapaEmitter.emit({
            value: resultado
        });
    }

    isEncontreSeuDentista() {
        return localStorage.getItem('modo') == Modo.encontreSeuDentista;
    }

    abrirSite(e: Event, site: string) {
        e.stopPropagation();
        window.open(`http://${site}`, '_blank');     
        return false;   
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pesquisa/resultado-pesquisa/resultado-pesquisa.component.ts
 **/